import type { ButtonProps } from './Button';
import type { Ref } from 'react';

import { forwardRef } from 'react';
import { css, styled } from 'styled-components';

import { ButtonContent, DefaultButtonSC } from './Button';

export const whiteButtonColors = css`
  background: ${(props) => props.theme.colors.transparent};
  border-color: ${(props) => props.theme.colors.whiteLight};
  color: ${(props) => props.theme.colors.whiteLight};

  &:hover {
    background: ${(props) => props.theme.colors.whiteLight};
    border-color: ${(props) => props.theme.colors.whiteLight};
    color: ${(props) => props.theme.colors.oxfordBlue[100]};
  }

  &[disabled],
  &:disabled {
    background: ${(props) => props.theme.colors.transparent};
    border-color: ${(props) => props.theme.colors.oxfordBlue[30]};
    color: ${(props) => props.theme.colors.oxfordBlue[30]};
  }
`;

const WhiteButtonSC = styled(DefaultButtonSC)`
  ${whiteButtonColors};
  border: 0.125rem solid;
  border-radius: 1.625rem;
`;

export const WhiteButton = forwardRef(
  ({ children, leftIcon, rightIcon, size, ...props }: ButtonProps, ref: Ref<HTMLButtonElement>) => {
    return (
      <WhiteButtonSC ref={ref} $size={size} {...props}>
        <ButtonContent leftIcon={leftIcon} rightIcon={rightIcon}>
          {children}
        </ButtonContent>
      </WhiteButtonSC>
    );
  },
);
